export default __webpack_public_path__ + "static/media/girl.de138859.png";